import { SVGAttributes } from "react";

export const AnchorIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" | "regular" }
) => {
  if (props.size === "small") {
    return (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 3a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 00-1 5.83V7H5a1 1 0 000 2h2v4.452c-1.406-.142-2.272-.58-2.828-1.037-.693-.57-1.016-1.256-1.253-1.809a1 1 0 00-1.838.788c.263.613.74 1.677 1.822 2.566C4 14.862 5.613 15.5 8 15.5c2.387 0 4-.638 5.097-1.54 1.082-.889 1.56-1.953 1.822-2.566a1 1 0 10-1.838-.788c-.237.553-.56 1.24-1.253 1.809-.556.457-1.422.895-2.828 1.037V9h2a1 1 0 100-2H9V5.83A3.001 3.001 0 008 0z"
          fill="currentColor"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 5a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 00-1 5.83V11H8a1 1 0 100 2h3v7.462c-2.213-.175-3.692-.921-4.676-1.733-1.143-.943-1.68-2.029-1.888-2.58a1 1 0 00-1.872.702c.293.782 1.005 2.197 2.487 3.42C6.551 21.51 8.779 22.5 12 22.5c3.222 0 5.45-.99 6.95-2.229 1.482-1.223 2.193-2.638 2.486-3.42a1 1 0 10-1.872-.702c-.207.551-.745 1.637-1.888 2.58-.984.812-2.462 1.558-4.676 1.733V13h3a1 1 0 100-2h-3V7.83A3.001 3.001 0 0012 2z"
          fill="currentColor"
        />
      </svg>
    );
  }
};
AnchorIcon.displayName = "AnchorIcon";
